import axios from "axios";

const getBaseURL = () => {
  if (process.env.NODE_ENV === "production") {
    const prodUrl = (
      process.env.REACT_APP_PRODUCTION_API_URL ||
      process.env.REACT_APP_API_URL ||
      "https://api.trustedcasinobrands.com"
    ).trim().replace(/\/+$/, "");
    return prodUrl.endsWith("/api") ? prodUrl : `${prodUrl}/api`;
  }

  if (process.env.REACT_APP_API_URL) {
    const rawUrl = process.env.REACT_APP_API_URL.trim().replace(/\/+$/, "");
    return rawUrl.endsWith("/api") ? rawUrl : `${rawUrl}/api`;
  }

  return "/api";
};

const API = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  timeout: 15000, // 15 seconds timeout
});

// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Guard against network errors where error.response is undefined
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default API;
